export default __webpack_public_path__ + "static/media/koleos-medium2.fe189319.jpg";